export const LISTING_STATUS = [
  { id: 'LISTED', displayValue: 'Listed' },
  { id: 'UNLISTED', displayValue: 'Unlisted' },
];
